$(document).ready(function() {

    /*
        GLOBAL
     */
    $(".fancybox").fancybox({
        backFocus : false
    });

    if ($(window).width() > 767) {
        $('#main-menu .navbar-nav .nav-item.has-submenu').on('hover', function () {
            $(this).find('> .submenu').toggle();
        });
    }

    $('#main-menu .navbar-nav .nav-item.has-submenu .chevron').on('click', function() {
        if ($(this).parent().hasClass('active')) {
            $(this).parent().removeClass('active');
        } else {
            $(this).parent().addClass('active');
        }

        $(this).parent().find('> .submenu').slideToggle();
    });

    // OFI
    objectFitImages();

    if (window.location.hash != '' && $(window.location.hash).length > 0 && window.location.hash != '#popup-coming-soon') {
        var header_height = $('header#header').height();

        setTimeout(function() {
            window.scrollTo(0, 0);
        }, 5);

        setTimeout(function() {

            $('body, html').animate({
                scrollTop: $(window.location.hash).offset().top - header_height - 25
            }, 700);
        }, 100);
    }

    $(document).on('click', '.product-item .product-content .buttons .show-select-qty', function() {
       $(this).closest('.buttons').hide();
       $(this).closest('.product-content').find('.after-buttons').show();
       return false;
    });

    $(document).on('click', '.product-item .product-content .after-buttons .input-group button', function() {
        var old_value = parseInt($(this).closest('.input-group').find('.qty-input').val());
        var new_value = 1;

        if ($(this).hasClass('minus')) {
            if (old_value != 0)
                new_value = old_value - 1;
            else
                new_value = 0;
        } else {
            new_value = old_value + 1;
        }

        $(this).closest('.input-group').find('.qty-input').val(new_value);
        $(this).closest('.after-buttons').find('.add_to_cart_button').attr('data-quantity', new_value);

        return false;
    });

    $(document).on('keyup', '.product-item .product-content .after-buttons .input-group input', function() {
        $(this).closest('.after-buttons').find('.add_to_cart_button').attr('data-quantity', parseInt($(this).val()));

        return false;
    });

    $(document).on('click', 'header#header #link-actions .toggle-search', function() {
        $(this).nextAll('.is-search-form').fadeIn();
        return false;
    });

    $(document).on('click', 'header#header #link-actions .is-search-form label .close-input', function() {
        $(this).closest('.is-search-form').fadeOut();
        return false;
    });

    $(document).on('click', 'body.woocommerce-cart .woocommerce-cart-form .product-quantity .input-group button', function() {
        var old_value = parseInt($(this).closest('.input-group').find('.qty').val());
        var new_value = 1;

        if ($(this).hasClass('minus')) {
            if (old_value != 0)
                new_value = old_value - 1;
            else
                new_value = 0;
        } else {
            new_value = old_value + 1;
        }

        $(this).closest('.input-group').find('.qty').val(new_value);
        $( '.woocommerce-cart-form :input[name="update_cart"]' ).prop( 'disabled', false );

        return false;
    });

    $('#launch-popup-coming-soon, .launch-popup-coming-soon').fancybox();

    $(document).on('change', '#popup-coming-soon .choice-b2c-b2b input[name="choice-type-client"]', function() {
        var customer_type = $(this).val();

        if (customer_type == 'b2c') {
            $('#form-newsletter-b2c').show();
            $('#form-newsletter-b2b').hide();
        } else {
            $('#form-newsletter-b2c').hide();
            $('#form-newsletter-b2b').show();
        }
    });

    $('.go-to-top').on('click', function () {
        $('html, body').animate({scrollTop: 0});

        return false;
    });
});
